
export namespace Utilities_Types {
  /**
   * Defined the fields for the Scheduling form. 
   */
  export interface AutoSchedule {
    date_option?: string;
    date_interval?: any;
    time_option?: string;
    time_interval?: any;
    time_offset?: number;
    time_zone?: { country?: string, utc?: string, time_zone?: string };
  }
  /**
   * Defined the fields from the configuration object.
   */
  export interface Configuration {
    configuration_id?: string;
    application_name?: string;
    user_name?: string;
    name?: string;
    value?: string;
    notes?: string;
    string_1?: string;
    string_2?: string;
    string_3?: string;
    created_by?: string;
    created_on?: string;
    modified_by?: string;
    modified_on?: string;
    date_number?: number;
  }
  /**
   * Defined the fields from the logging object.
   */
  export interface Log {
    log_id?: string;
    application_name?: string;
    process_name?: string;
    transaction_id?: string;
    level?: number;
    notes?: string;
    message?: string;
    created_by?: string;
    created_on?: string;
    alerted_on?: string;
    number_1?: number;
    number_2?: number;
    number_3?: number;
    number_4?: number;
    number_5?: number;
    string_1?: string;
    string_2?: string;
    string_3?: string;
    string_4?: string;
    string_5?: string;
    date_number?: number;
  }
  /**
   * Defined the fields from the message object.
   */
  export interface Message {
    message_id?: string;
    application_name?: string;
    process_name?: string;
    transaction_type?: string;
    transaction_id?: string;
    status_name?: string;
    environment?: string;
    direction?: string;
    reference?: string;
    payload?: string;
    notes?: string;
    message?: string;
    created_by?: string;
    created_on?: string;
    modified_by?: string;
    modified_on?: string;
    number_1?: number;
    number_2?: number;
    number_3?: number;
    number_4?: number;
    number_5?: number;
    string_1?: string;
    string_2?: string;
    string_3?: string;
    string_4?: string;
    string_5?: string;
    date_number?: number;
  }
  /**
   * Represents supported AWI entities.
   */
  export enum e_awi_entity {
    Material = 'material_id',
    Project = 'project_id',
    Owner = 'owner_id',
    Warehouse = 'warehouse_id',
    Account = 'account_id',
    OrderClass = 'order_class_id',
    MaterialGroup = 'material_group_id',
    Global = ' '
  }
  /**
   * Supported scopes for AWI configurations.
   */
  export enum e_awi_scopes {
    Allocation = 'Allocation',
    Cartonization = 'Cartonization',
    Palletization = 'Palletization',
    Totenization = 'Totenization'
  }
  /**
   * Enumeration containing toaster type options.
   */
  export enum e_toaster_type {
    Error = 0,
    Warning = 1,
    Info = 2,
    Success = 3
  }
}

export namespace $frontendTypes {
  // @ts-ignore
  export import Utilities = Utilities_Types;
}




